"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const useLogin = (userData) => {
    const [isLoginRequired, setIsLoginRequired] = (0, react_1.useState)(false);
    const [loginUrl, setLoginUrl] = (0, react_1.useState)("");
    (0, react_1.useEffect)(() => {
        if (!(Object.keys(userData).length > 0)) {
            return;
        }
        const { loginProviders, loginConfiguration } = userData;
        if (loginProviders.length > 0) {
            const loginProvider = loginProviders[0];
            if (loginConfiguration.bookingRequiresLoginWith) {
                if (!loginProvider.loggedIn &&
                    loginConfiguration.bookingRequiresLoginWith.includes(loginProvider.slug)) {
                    setIsLoginRequired(true);
                    setLoginUrl(`${userData.loginProviders[0].loginUrl}&redirect_back_to=${window.location.href}`);
                }
            }
        }
    }, [userData]);
    return {
        isLoginRequired,
        loginUrl,
    };
};
exports.default = useLogin;
